import request from '@/utils/request'


// 市场行情列表
export function listMarketByType(param) {
    return request({
        url: `/swx/customer/index/listMarketByType`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// k线图
export function getKValueByCodeAndDate(param) {
    return request({
        url: `/swx/customer/index/getKValueByCodeAndDate`,
        method: 'get',
        params: {
            ...param
        }
    })
}
// getMarketInfo
export function getMarketInfo(id) {
    return request({
        url: `/swx/customer/index/getMarketInfo/${id}`,
        method: 'get',
        // params: {
        //     ...param
        // }
    })
}
// listContents
export function listContents(lang) {
    return request({
        url: `/swx/customer/index/listContents/${lang}`,
        method: 'get',
    })
}

// 分时图跳动问题诊断日志上报
export function reportChartJumpDiag(data) {
    return request({
        url: `/swx/customer/diag/chart-jump`,
        method: 'post',
        data
    })
}
// /getContentsById/{id}
export function getContentsById(id) {
    return request({
        url: `/swx/customer/index/getContentsById/${id}`,
        method: 'get',
    })
}

// /getParamByKey/{key}
export function getParamByKey(key) {
    // withdrawal_fee 提现手续费
    // recharge_account 充值账号


    return request({
        url: `/swx/customer/index/getParamByKey/${key}`,
        method: 'get',
    })
}

// listNft
export function listNft(param) {
    return request({
        url: `/swx/customer/index/listNft`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// 获取ETH/USDT实时汇率
export function getEthToUsdtRate() {
    return request({
        url: `/swx/customer/index/getEthToUsdtRate`,
        method: 'get'
    })
}

// listLoanSettings
export function listLoanSettings() {
    return request({
        url: `/swx/customer/index/listLoanSettings`,
        method: 'get'
    })
}

// listFinancialProducts
export function listFinancialProducts() {
    return request({
        url: `/swx/customer/index/listFinancialProducts`,
        method: 'get'
    })
}

// invest
export function investFinancial(data) {
    return request({
        url: `/swx/customer/financial/invest`,
        method: 'post',
        data
    })
}

// myFinancialOrders
export function myFinancialOrders(params) {
    return request({
        url: `/swx/customer/financial/myOrders`,
        method: 'get',
        params
    })
}

// getFinancialOrderDetail
export function getFinancialOrderDetail(id) {
    return request({
        url: `/swx/customer/financial/orderDetail/${id}`,
        method: 'get'
    })
}

// buySmart
export function buySmart(data) {
    return request({
        url: `/swx/customer/order/buySmart`,
        method: 'post',
        data
    })
}

// 🎯 虚拟账户智能交易下单
export function buySmartVirtually(data) {
    return request({
        url: `/swx/customer/order/buySmartVirtually`,
        method: 'post',
        data
    })
}
// listSmartOrder
export function listSmartOrder(param) {
    return request({
        url: `/swx/customer/order/listSmartOrder`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// buyOptions
export function buyOptions(data) {
    return request({
        url: `/swx/customer/order/buyOptions`,
        method: 'post',
        data
    })
}

export function getOptionsOrderById(id) {
    return request({
        url: `/swx/customer/order/getOptionsOrderById/${id}`,
        method: 'get',
    })
}

// 🎯 获取期权订单实时价格 - 确保前后端价格同步
export function getOptionsCurrentPrice(id) {
    return request({
        url: `/swx/customer/order/getOptionsCurrentPrice/${id}`,
        method: 'get',
    })
}
// listOptionsOrder
export function listOptionsOrder(param) {
    return request({
        url: `/swx/customer/order/listOptionsOrder`,
        method: 'get',
        params: {
            ...param
        }
    })
}

export function userContractsOrders(param) {
    return request({
        url: `/swx/customer/contracts/orders`,
        method: 'get',
        params: {
            ...param
        }
    })
}

export function userWalletOrders(param) {
    return request({
        url: `/swx/customer/wallet-orders`,
        method: 'get',
        params: {
            ...param
        }
    })
}

export function listOptionsConfig() {
    return request({
        url: `/swx/customer/user/listOptionsConfig`,
        method: 'get',
    })
}

export function allOrdersAggregated(param) {
    return request({
        url: `/swx/customer/allOrders/all`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// 🎯 获取单个产品的实时价格
export function getRealtimePrice(marketCode) {
    return request({
        url: `/swx/customer/market/realtime-price/${marketCode}`,
        method: 'get'
    })
}

// 🎯 批量获取多个产品的实时价格
export function getRealtimePrices(marketCodes) {
    return request({
        url: `/swx/customer/market/realtime-prices`,
        method: 'get',
        params: {
            marketCodes: marketCodes.join(',')
        }
    })
}
